import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { Grid, Button as ButtonMUI } from '@mui/material';
import { IDistrictViewModel } from 'viewModels';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { DropListStatesBrazillian } from '../DropListStatesBrazillian';
import { Container, Content } from './styles';
import { Button } from '../Buttons/Button';
import { useDistricts } from '../../context/districts';
import { DropListDistricts } from '../DropListDistricts';
import { UF_KEYS } from '../../constants';
import { changeSpaceToUnderline } from '../../utils/changeSpaceToUnderline';

interface IProps {
  handleDistrictsSelected: (districts: IDistrictViewModel[]) => void;
}

export function FormDistrictsOfOperation({ handleDistrictsSelected }: IProps) {
  const [isLoadingDistricts, setIsLoadingDistricts] = useState(false);
  const [districtsSelected, setDistrictsSelected] = useState<IDistrictViewModel[]>([]);
  const [suggestDistricts, setSuggestDistricts] = useState<IDistrictViewModel[]>([]);
  const [numberDistrictsRendered, setNumberDistrictsRendered] = useState(6);

  const {
    districtsSelectedsByUser,
    districts,
    fetchNextPageDistrictsSelectedByUser,
    hasNextPageDistrictsSelectedByUser,
  } = useDistricts();
  const [ufCodeSelected, setUfCodeSelected] = useState(0);

  const handleDistrictChange = (district: IDistrictViewModel) => {
    const isExists = districtsSelected.some((d) => d.id === district.id);
    if (isExists) {
      const reaminingDistricts = districtsSelected.filter((d) => d.id !== district.id);
      setDistrictsSelected(() => reaminingDistricts);
      handleDistrictsSelected(reaminingDistricts);
    } else {
      setDistrictsSelected((prev) => [...prev, district]);
      handleDistrictsSelected([...districtsSelected, district]);
      handleGetSuggestDistricts(district);
    }
  };

  const handleSelectSuggestionDistrict = (district: IDistrictViewModel) => {
    const districtAlreadySelected = districtsSelected.find((s) => s.id === district.id);
    if (!districtAlreadySelected) {
      const newDistrictSelected = [...districtsSelected, district];
      setDistrictsSelected(newDistrictSelected);
      handleDistrictsSelected(newDistrictSelected);
    }
  };

  const handleGetSuggestDistricts = (district: IDistrictViewModel) => {
    const districtsSuggested = districts.filter(
      (d) => d.microregionId === district.microregionId && d.id !== district.id,
    );
    setSuggestDistricts(districtsSuggested);
  };

  const handleSeeMoreSuggestedDistricts = () => {
    setNumberDistrictsRendered(suggestDistricts.length);
  };
  const handleSelectAllSuggestedDistricts = () => {
    const suggestedDistrictsNotSelected = suggestDistricts
      .filter((s) => !districtsSelected.find((c) => c.id === s.id))
      .slice(0, numberDistrictsRendered);
    const newDistrictsSelected = [...districtsSelected, ...suggestedDistrictsNotSelected];
    setDistrictsSelected(newDistrictsSelected);
    handleDistrictsSelected(newDistrictsSelected);
  };

  const handleFetchNextPageDistrictsSelectedByUser = () => {
    setIsLoadingDistricts(true);
    fetchNextPageDistrictsSelectedByUser();
    setIsLoadingDistricts(false);
  };

  useEffect(() => {
    setDistrictsSelected(districtsSelectedsByUser);
  }, [districtsSelectedsByUser]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoadingDistricts(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [isLoadingDistricts]);

  return (
    <Container>
      <Content>
        <div className="containerDropdown">
          <div className="contentDropdown">
            <DropListStatesBrazillian
              placeholderTitle="Estado"
              onChange={(ufCode) => setUfCodeSelected(ufCode)}
            />
          </div>
          <div className="contentDropdown">
            <DropListDistricts
              disabled={!ufCodeSelected}
              placeholderTitle="Selecione"
              ufCode={ufCodeSelected}
              selectedDistricts={districtsSelected}
              name="districtState"
              onDistrictChange={handleDistrictChange}
            />
          </div>
        </div>
        {suggestDistricts.length > 0 && (
          <div className="containerCitiesSuggested">
            <h2>Quem escolheu essa comarca também escolheu: </h2>
            <div className="contentCities">
              {suggestDistricts
                .map((c) => (
                  <div key={c.id}>
                    <ButtonMUI
                      className={
                        districtsSelected.some((s) => s.id === c.id) ? 'selected' : 'notSelected'
                      }
                      onClick={() => handleSelectSuggestionDistrict(c)}>
                      {c.name}
                    </ButtonMUI>
                  </div>
                ))
                .slice(0, numberDistrictsRendered)}
            </div>
            <div className="containerButtons">
              <ButtonMUI onClick={handleSelectAllSuggestedDistricts}>Selecionar todos</ButtonMUI>
              {suggestDistricts.length > numberDistrictsRendered && (
                <ButtonMUI onClick={handleSeeMoreSuggestedDistricts}>
                  Ver mais <KeyboardDoubleArrowDownIcon />
                </ButtonMUI>
              )}
            </div>
          </div>
        )}
        {districtsSelected.length > 0 && (
          <div className="containerCitites">
            <h2>Comarcas selecionadas:</h2>
            <div className="contentCities">
              {districtsSelected.map((district) => (
                <div key={district.id}>
                  <div className="cities">
                    {district.name} - {UF_KEYS[changeSpaceToUnderline(district.uf)]}
                    <button type="button" onClick={() => handleDistrictChange(district)}>
                      <CloseIcon fontSize="small" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {hasNextPageDistrictsSelectedByUser && (
              <Grid container justifyContent="center" padding="1rem 1rem">
                <Button
                  text="Carregar mais..."
                  onClick={handleFetchNextPageDistrictsSelectedByUser}
                  dimensions={{ height: '2rem', width: '10rem' }}
                  color="primary"
                  textHoverColor="tertiary_500"
                  backgroundHoverColor="transparent"
                  background="transparent"
                  border={{ color: 'transparent' }}
                  loading={isLoadingDistricts}
                  disabled={isLoadingDistricts}
                />
              </Grid>
            )}
          </div>
        )}
      </Content>
    </Container>
  );
}
